module.exports = __webpack_public_path__ + "img/oran_5kl.8f6d0408.jpg";